// extracted by mini-css-extract-plugin
export default {"apple-button":"static-React-HVJS-HVUI-ApplePassButton-___ApplePassButton-module__apple-button"};